import { createReducer } from '../../helpers/reducer';

const initState = {
  comments: null,
  loading: false,
  sending: false,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  return {
    ...state,
    ...payload,
    loading: false,
  };
}

function onLoadMoreSuccess(state, { payload }) {
  return {
    ...state,
    ...payload,
    comments: [...state.comments, ...payload.comments],
    loading: false,
  };
}

function onSendComment(state) {
  return {
    ...state,
    sending: true,
  };
}

function onSendCommentSuccess(state) {
  return {
    ...state,
    sending: false,
  };
}

function onSendCommentFailed(state) {
  return {
    ...state,
    sending: false,
  };
}

function onClearStore() {
  return { ...initState };
}

const getCommentReducer = actions => {
  return createReducer(initState, {
    [actions.LOAD]: onLoad,
    [actions.LOAD_SUCCESS]: onLoadSuccess,
    [actions.LOAD_MORE]: onLoad,
    [actions.LOAD_MORE_SUCCESS]: onLoadMoreSuccess,
    [actions.SEND_COMMENT]: onSendComment,
    [actions.SEND_COMMENT_SUCCESS]: onSendCommentSuccess,
    [actions.SEND_COMMENT_FAILED]: onSendCommentFailed,
    [actions.CLEAR_STORE]: onClearStore,
  });
};

export default getCommentReducer;
